'use client';
import type { Event_Entry } from '@/types/graphql';
import { useTranslations } from 'next-intl';
import ShowDateTime from '../ShowDateTime';
import ShowPurchaseButton from './ShowPurchaseButton';
interface StickyShowPurchaseBarProps {
    event: Event_Entry;
    price: string | null;
    show: boolean;
    locale: string;
}

export default function StickyShowPurchaseBar({
    event,
    price,
    show,
    locale,
}: StickyShowPurchaseBarProps) {
    const t = useTranslations('ShowPurchaseButton');
    if (!show) return null;
    return (
        <div className="pointer-events-none fixed bottom-0 left-0 z-40 flex w-full justify-center">
            <div className="pointer-events-auto w-full max-w-lg px-4 pr-24 pb-4 lg:max-w-screen-md lg:px-20">
                <div className="flex flex-col gap-2 rounded-lg border border-haug-choco-30 bg-haug-ivory-30 p-4 shadow-lg md:flex-row md:items-center">
                    <div className="flex flex-1 flex-row justify-between gap-2 font-bold font-neue-haas text-xs uppercase md:items-center md:justify-start md:text-sm">
                        <ShowDateTime event={event} locale={locale} />
                        {price && (
                            <span className="md:ml-4">
                                {t('price')}: {price}
                            </span>
                        )}
                    </div>
                    <div className="w-full md:w-auto">
                        <ShowPurchaseButton event={event} />
                    </div>
                </div>
            </div>
        </div>
    );
}
